import VueX from '@/store';
const Store = () => import('@/modules/store/index.vue');

export default [
  {
    path: '/franquia/:franchise_id/lojas/:id',
    name: 'store',
    component: () => import('../index.vue'),
    meta: {
      navbarTitle: () => VueX.getters['newStore/getCurrentStore'].name,
      drawerComponent: () => import('@/modules/store/_components/StoreFormBase'),
      nameCity: true,
    },
  },
  {
    path: '/lojas/:id/faturas',
    name: 'store-invoices',
    component: Store,
  },
  {
    path: '/lojas/:id/pedidos',
    name: 'store-orders',
    component: Store,
  },
  {
    path: '/lojas/:id/entregadores',
    name: 'store-drivers',
    component: Store,
    meta: {  
      navbarTitle: () => 'Entregadores atribuídos',
      nameCity: true,
    },
  },
  {
    path: '/lojas/:id/areas',
    name: 'store-shipment-areas',
    component: Store,
    meta: {
      navbarTitle: () => 'Áreas de entrega',
      nameCity: true,
    },
  },
  {
    path: ':id/formas-de-pagamento',
    name: 'store-payment-types',
    component: Store,
  },
];
